import { REG_CAT_PATH, REG_LIST_PATH, REG_PRODUCT_PATH, REG_TECHNICAL_GUIDE_PATH } from 'base/config/constant';

export const getQueryFromPath = (path?: string): Record<string, any> => {
    if (!path) {
        return {};
    }
    let o: Record<string, any> = {};
    if (REG_LIST_PATH.test(path)) {
        o.listSn = path.replace(/.*-c(\d+).*/, '$1');
    } else if (REG_CAT_PATH.test(path)) {
        o.catId = path.replace(/.*-a(\d+).*/, '$1');
    } else if (REG_PRODUCT_PATH.test(path)) {
        o.productId = path.replace(/.*-p(\d+)(-v\d+)*$/, '$1');
        if (/-v\d+/.test(path)) {
            o.variantId = path.replace(/.*-v(\d+)$/, '$1');
        }
    } else if (REG_TECHNICAL_GUIDE_PATH.test(path)) {
        o.articleGid = path.replace(/.*-t(\d+).*/, '$1');
    }
    return o;
};


// 获取哈希值并去除#号
export const getUrlHash = () => {
    return decodeURIComponent(window.location.hash.replace('#', ''));
}